import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeleportToDirective } from './directives/teleport-to.directive';
import { SpinnerDirective } from './directives/spinner.directive';
import { ExportToExcelDirective } from './directives/export-to-excel.directive';
import { horizontalScrollDirective } from "./directives/horizontal-scroll.directive";
import { TimeBackAgoDirective } from './directives/time-back-ago.directive';
import { FromToDirective } from './directives/from-to.directive';
import { CheckboxClassDirective } from './components/checkbox-search-list/checkbox-class.directive';
import { ControlErrorDirectiveDirective } from "./directives/control-error-directive.directive";
import { ResizableDirective } from "./directives/resizable.directive";
import { ClassByConditionDirective } from './directives/class-by-condition.directive';

const directives = [
  ClassByConditionDirective,
  TeleportToDirective,
  ExportToExcelDirective,
  horizontalScrollDirective,
  TimeBackAgoDirective,
  FromToDirective,
  CheckboxClassDirective,
  ControlErrorDirectiveDirective,
  ResizableDirective
]

@NgModule({
  declarations: [directives],
  imports: [
    CommonModule,
    SpinnerDirective
  ],
  exports: [directives, SpinnerDirective]
})
export class SharedDirectivesModule {
}
